import { CapoPlugin } from "/home/runner/work/leilakrejci/leilakrejci/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];